import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import ShortTermOwnerCreateForm from './ShortTermOwnerCreateForm';

const ShortTermOwnerCreateFormPage = () => {
    return (
        <Container className="mt-5 mb-3 pt-5">
            <Row className="col-6 mx-auto">
                <ShortTermOwnerCreateForm />
            </Row>
        </Container>
    );
};

export default ShortTermOwnerCreateFormPage;
